import { GOOGLE_ADS_ID } from '../config/runtimeConfig';
import { GOOGLE_ADS_SCRIPT_ORIGIN } from '../constants/GoogleAds';

const CONSENT_ADS_DENIED = {
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
  analytics_storage: 'denied',
};

const CONSENT_ADS_GRANTED = {
  ad_storage: 'granted',
  ad_user_data: 'granted',
  ad_personalization: 'granted',
};

function ensureGtag() {
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }
  return window.gtag;
}

function getTagScriptSrc(tagId) {
  return `${GOOGLE_ADS_SCRIPT_ORIGIN}/gtag/js?id=${encodeURIComponent(tagId)}`;
}

export function initGoogleAdsTag() {
  if (typeof window === 'undefined' || !GOOGLE_ADS_ID) {
    return;
  }

  const gtag = ensureGtag();
  const src = getTagScriptSrc(GOOGLE_ADS_ID);
  if (document.querySelector(`script[src="${src}"]`)) {
    return;
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = src;
  document.head.appendChild(script);

  gtag('js', new Date());
  gtag('config', GOOGLE_ADS_ID);
}

export function syncGoogleAdsConsent(advertisingAllowed) {
  if (typeof window === 'undefined') {
    return;
  }

  const gtag = ensureGtag();
  gtag('consent', 'update', advertisingAllowed ? CONSENT_ADS_GRANTED : CONSENT_ADS_DENIED);
}
